








































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { User, UserRoles, UserRole } from "bancojs";
import { getRoleString } from "@/views/admin/users/Index.vue";
import { $api } from "@/services/ApiService";

@Component
export default class MyProfile extends Vue {
  async created() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.form.loading = true;
      const res = await $api.client.user.profile.get().toPromise();
      this.form.data = Object.assign(this.form.data, res);
    } catch (err) {
      console.log(err);
    } finally {
      this.form.loading = false;
    }
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    email: (val: any) => /.+@.+/.test(val) || 'Email inválido.',
  };

  get roles() {
    return UserRoles.map((role) => {
      return { text: getRoleString(role as UserRole), value: role };
    });
  }

  async saveUser() {
    this.form.data.name =
      this.form.data.firstname + " " + this.form.data.lastname;
    try {
      this.form.saving = true;
      const user = await $api.client.user.profile
        .update(this.form.data)
        .toPromise();

      this.form.saving = false;
      this.form.data = Object.assign(this.form.data, user);
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  toBase64(file: File) {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  @Watch("form.signatureFile")
  async onSignatureFileChange(val: File) {
    if (val) {
      this.form.data.signature = await this.toBase64(val);
    } else {
      this.form.data.signature = "";
    }
  }

  form: {
    data: User;
    loading: boolean;
    validForm: boolean;
    saving: boolean;
    signatureFile: File | null;
  } = {
    data: {
      id: "",
      firstname: "",
      lastname: "",
      name: "",
      email: "",
      state: "ACTIVE",
      roles: [],
      dni: "",
      signature: "",
    },
    loading: true,
    saving: false,
    validForm: false,
    signatureFile: null,
  };
}
